<template>
  <v-dialog width="400px" v-model="viewMenu">
    <v-card class="px-7 pb-2">
        <v-card-title class="mx-n7 popup-header">{{title}}</v-card-title>
        <v-layout row wrap v-if="querschnitt">
          <v-flex xs4>
            <v-subheader class="px-0" v-text="'Name:'"></v-subheader>                  
          </v-flex>
          <v-flex xs8>
            <v-text-field label="Name" type="text" v-model="querschnitt.name" required></v-text-field>
          </v-flex> 
          <v-flex xs4>
            <v-subheader class="px-0" v-text="'Fläche:'"></v-subheader>                  
          </v-flex>       
          <v-flex xs8>
              <v-text-field label="Fläche" type="number" v-model.number="querschnitt.Fläche" :suffix="LängenEinheit.name + '²'" required></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="px-0" v-text="'Trägheitsmoment:'"></v-subheader>                  
          </v-flex>       
          <v-flex xs8>
              <v-text-field label="Trägheitsmoment" type="number" v-model.number="querschnitt.Trägheitsmoment" :suffix="LängenEinheit.name + '⁴'" required></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="px-0" v-text="'Material:'"></v-subheader>                  
          </v-flex> 
          <v-flex xs6>
            <v-select label="Material" v-bind:items="materialliste" item-text="name" dense :menu-props="{ offsetY: true }" return-object v-model="querschnitt.Material"></v-select>
          </v-flex>
          <v-flex xs2 class="text-xs-left">
            <v-btn-toggle>
              <v-icon class="pt-3 px-1" flat color="green" @click="$store.commit('newMaterial')">add</v-icon>
              <v-icon class="pt-3 px-1" flat color="orange" v-if="querschnitt.Material" @click="$store.commit('editMaterial',querschnitt.Material)">edit</v-icon>
            </v-btn-toggle>
          </v-flex>      
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions>
                <v-btn small @click="apply()" color="grey lighten-2" >Übernehmen</v-btn>
                <v-btn small @click="cancel()" color="grey lighten-2" >Abbrechen</v-btn>
                <v-btn small v-if="!$store.getters.newQuerschnitt" @click="deleteQuerschnitt()" color="grey lighten-2"><v-icon dark color="red">delete_forever</v-icon>Löschen</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import Querschnitt from '../../js/Querschnitt.js'

export default {
    data(){
        return{
            querschnitt: undefined,
            LängenEinheit: this.$store.state.LängenEinheiten.cm,
        }
    },
    computed: {
        materialliste() { return this.$store.state.StatikSystem.Materialliste },
        title() { return this.$store.getters.newQuerschnitt == true ? 'Neuer Querschnitt' : 'Querschnitt Bearbeiten'},
        viewMenu: {
            get() { return this.$store.getters.vQuerschnittMenu },   
            set(value) { this.$store.commit('setvQuerschnittMenu', value)} 
        },
        cQuerschnitt() { return this.$store.getters.cQuerschnitt },
    },
    methods: {
        // removeMaterial(){
        //   this.auflager = null
        // },
        apply(){
            this.querschnitt.Fläche *= (this.LängenEinheit.value*this.LängenEinheit.value)
            this.querschnitt.Trägheitsmoment *= (this.LängenEinheit.value*this.LängenEinheit.value*this.LängenEinheit.value*this.LängenEinheit.value)
            this.$store.commit('QuerschnittDialogApply', this.querschnitt)
            this.querschnitt = undefined
        },
        cancel(){
            this.viewMenu = false
            this.querschnitt = undefined
        },
        deleteQuerschnitt(){
            this.$store.commit('QuerschnittDialogDelete')
        }
    },
    beforeUpdate(){
        if (!this.querschnitt && this.viewMenu) {
          const cFläche = this.cQuerschnitt.Fläche/this.LängenEinheit.value/this.LängenEinheit.value
          const cTrägheitsmoment = this.cQuerschnitt.Trägheitsmoment/this.LängenEinheit.value/this.LängenEinheit.value/this.LängenEinheit.value/this.LängenEinheit.value
          this.querschnitt = new Querschnitt(null,cFläche,cTrägheitsmoment,this.cQuerschnitt.Material,this.cQuerschnitt.name)
        } 
    },
}
</script>
